
import { get } from "./helper_api"
import * as url from "./helper_path"

const findProfileLederByCodeAPI = params => get(url.GET_BY_LEDGER_CODE.concat('/').concat(params)).catch(err => err)

export {
    findProfileLederByCodeAPI
}
